module.exports = __webpack_public_path__ + "img/rzlr.14f202a5.svg";